import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex w-full h-mob-48 sm:h-tab-50 lg:h-web-52 bg-white border border-[#e1e1e1] rounded-mob-4 lg:rounded-web-6 sm:rounded-tab-4 outline-none px-mob-17 lg:px-web-20 sm:px-tab-17 text-mob-16 sm:text-tab-16 lg:text-web-20  file:border-0 file:bg-transparent file:font-medium file:text-foreground placeholder:text-muted-foreground focus:outline-[1px] focus:border-none focus:outline-gray-400  disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
